import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';

import { useInnerWidth } from '../../hooks';

import styles from './index.module.css';

const propTypes = {
  children: PropTypes.any.isRequired,
  primaryIconColor: PropTypes.string,
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.object,
};

const defaultProps = {
  primaryIconColor: '#666',
  containerClassName: '',
  containerStyle: {},
};

const MAX_BLOCK_WIDTH = 350; //px

const ToolTip = ({ children, primaryIconColor, containerClassName, containerStyle }) => {
  const iconRef = React.useRef(null);
  const tipBlockRef = React.useRef(null);
  const arrowRef = React.useRef(null);

  const width = useInnerWidth();

  const mouseEntered = useCallback(
    (e) => {
      if (iconRef.current && tipBlockRef.current && arrowRef.current) {
        tipBlockRef.current.style.top = e.clientY + 10 + 'px';
        arrowRef.current.style.top = e.clientY + 3 + 'px';
        const iconRect = iconRef.current.getBoundingClientRect();
        arrowRef.current.style.left = iconRect.left + 5 + 'px';

        tipBlockRef.current.style.width = '90vw';
        const remainingWidth = width - iconRect.left;
        if (remainingWidth < MAX_BLOCK_WIDTH) {
          const calulatedLeft = iconRect.left - (MAX_BLOCK_WIDTH - remainingWidth);
          tipBlockRef.current.style.left = (calulatedLeft < 5 ? 5 : calulatedLeft) + 'px';
        } else {
          tipBlockRef.current.style.left = iconRect.left - 10 + 'px';
        }
      }
    },
    [width, iconRef.current, tipBlockRef.current, arrowRef.current]
  );

  return (
    <span
      className={`${styles['tip-container']} ${containerClassName}`}
      style={containerStyle}
      onMouseEnter={mouseEntered}
    >
      <span
        className="tip-icon icon-info-icon"
        ref={iconRef}
        style={{ fontSize: 20, color: primaryIconColor }}
      >
        {''}
      </span>
      <span className="arrow" ref={arrowRef} />
      <span
        style={{ maxWidth: MAX_BLOCK_WIDTH + 'px', visibility: 'hidden' }}
        className="tip-block"
        ref={tipBlockRef}
      >
        {children}
      </span>
    </span>
  );
};

ToolTip.propTypes = propTypes;
ToolTip.defaultProps = defaultProps;

export default ToolTip;
